import { createSlice } from "@reduxjs/toolkit";
import {
  addUser,
  editUser,
  getUser,
  getUserList,
} from "../services/user-service";

const initialState = {
  users: [],
  userProfile: null,
  user: null,
  pagination: null,
  error: [],
  loading: false,
  otpSuccessMessage: null,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },
    resetDashboard(state) {
      state.successMessage = null;
    },
    resetState(state) {
      state.success = false;
    },
    saveUserProfile(state, action) {
      state.userProfile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.users = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getUserList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.users = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.users = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.users = action.payload.data.item;
        state.successMessage = action.payload.message;
        state.otpSuccessMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      });
  },
});
export const {
  resetSuccess,
  resetState,
  resetError,
  saveUserProfile,
  resetDashboard,
} = userSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default userSlice.reducer;
